














































import { Component, Vue } from "vue-property-decorator";
import { dangisWiki as wiki } from "@/config/host.config";
import { IWikiConfig } from "@/@types/wiki/wiki-config";
import { AxiosResponse } from "axios";
import QuickChangeInput from "@/components/forms/quick-change-input.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: { StandartModal, QuickChangeInput },
})
export default class WikiConfigSettings extends Vue {
  quickChange = "";
  local_gps_interval = 0;
  near_radius_metres = 0;

  async createWikiConfig(): Promise<void> {
    try {
      const confres: AxiosResponse<IWikiConfig> = await this.$axios.get(
        wiki.config.main
      );
      if (confres.status === 200) {
        this.local_gps_interval = confres.data.local_gps_interval;
        this.near_radius_metres = confres.data.near_radius_metres;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async updateConfig(data: Partial<IWikiConfig>): Promise<void> {
    try {
      const confres = await this.$axios.put(wiki.config.main, data);
      if (confres.status === 200)
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
    } catch (error) {
      console.error(error);
      this.onError();
    }
  }

  onError(): void {
    this.$notify({
      group: "global",
      text: String(this.$i18n.t("alerts.emptyUpdate")),
      type: "warn",
    });
  }

  mounted(): void {
    this.createWikiConfig();
  }
}
